// KIMU 2.0 — Product form (variants, ATC, sticky mobile)
// -----------------------------------------

(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    // Acepta data-variants (array) o data-product-json legacy
    let variants;
    try {
      variants = JSON.parse(form.dataset.variants || form.dataset.productJson || '[]');
      if (variants && !Array.isArray(variants) && variants.variants) variants = variants.variants;
    } catch (e) { variants = []; }
    if (!Array.isArray(variants) || !variants.length) return;
    const data = { variants };

    const variantInput = form.querySelector('input[name="id"]');
    const priceEl = form.closest('.pdp__info, .product')?.querySelector('[data-price]');
    const priceCompareEl = form.closest('.pdp__info, .product')?.querySelector('[data-price-compare]');
    const submitBtn = form.querySelector('[data-add-to-cart]');
    const submitLabel = submitBtn ? submitBtn.textContent : 'Agregar al carrito';

    const variantButtons = form.querySelectorAll('[data-variant-id]');
    variantButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.variantId;
        variantButtons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        variantInput.value = id;
        const variant = data.variants.find((v) => String(v.id) === String(id));
        if (!variant) return;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (priceCompareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompareEl.textContent = formatMoney(variant.compare_at_price);
            priceCompareEl.hidden = false;
          } else {
            priceCompareEl.hidden = true;
          }
        }
        if (submitBtn) {
          if (!variant.available) {
            submitBtn.textContent = 'Agotado';
            submitBtn.disabled = true;
          } else {
            submitBtn.textContent = submitLabel;
            submitBtn.disabled = false;
          }
        }
        const sticky = document.querySelector('.sticky-atc [data-sticky-price]');
        if (sticky) sticky.textContent = formatMoney(variant.price);
        const stickyVariant = document.querySelector('.sticky-atc [data-sticky-variant]');
        if (stickyVariant) stickyVariant.textContent = variant.title;
        const buyNowBtn = form.querySelector('[data-buy-now]');
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;
      });
    });

    // Quantity
    const qtyInput = form.querySelector('[name="quantity"]');
    const qtyUp = form.querySelector('[data-qty-up]');
    const qtyDown = form.querySelector('[data-qty-down]');
    if (qtyUp && qtyInput) qtyUp.addEventListener('click', () => { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    if (qtyDown && qtyInput) qtyDown.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });

    // Submit via fetch → open cart drawer
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Agregando...'; }
      const fd = new FormData(form);
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd,
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status && res.status !== 200) {
            if (submitBtn) { submitBtn.textContent = res.description || 'Error'; }
            return;
          }
          if (window.kimuRefreshCart) window.kimuRefreshCart();
          const drawer = document.getElementById('cart-drawer');
          if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
          if (submitBtn) {
            submitBtn.textContent = '✓ Agregado';
            setTimeout(() => { submitBtn.textContent = submitLabel; submitBtn.disabled = false; }, 1500);
          }
        });
    });
  });

  // Buy now: agrega al carrito y va a checkout
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form[data-product-form]');
      if (!form) { window.location.href = '/checkout'; return; }
      btn.disabled = true;
      var prev = btn.textContent;
      btn.textContent = 'Procesando...';
      var fd = new FormData(form);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status && res.status !== 200) {
            btn.textContent = res.description || 'Error';
            btn.disabled = false;
            return;
          }
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.textContent = prev;
          btn.disabled = false;
        });
    });
  });

  // Sticky ATC visibility (mobile)
  const sticky = document.querySelector('.sticky-atc');
  const mainForm = document.querySelector('.pdp__info');
  if (sticky && mainForm) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) sticky.classList.add('is-visible');
        else sticky.classList.remove('is-visible');
      });
    }, { threshold: 0 });
    io.observe(mainForm);
  }

  // Gallery thumbs
  const gallery = document.querySelector('.pdp__gallery');
  if (gallery) {
    const mains = gallery.querySelectorAll('.pdp__gallery-main img');
    const thumbs = gallery.querySelectorAll('.pdp__thumbs button');
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        mains.forEach((m) => m.classList.remove('is-active'));
        thumbs.forEach((t) => t.classList.remove('is-active'));
        if (mains[i]) mains[i].classList.add('is-active');
        thumb.classList.add('is-active');
      });
    });
  }

  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }
})();
